/**
 * @module task_template.transformer
 */
import { defaultLang } from '~/config/settings/app.settings';
import { list } from '~/tools/list';
import { nums } from '~/tools/nums';
import { text } from '~/tools/text';

/**
 * Map list of tasks templates returned by server to usable format by
 * front-end UI. Used for action planning.
 *
 * @example template (from server)
 * [
 *   {
 *     "id": 1,
 *     "companyId": 2,
 *     "surveyTypeId": 123,
 *     "title": "This is my title",
 *     "description": "as dkfha sdfh kasdhfkj ahsdjkfh jkasdhf jkashd fajsd",
 *     "effectiveness": 1
 *     "status": 'draft'
 *     "categories": [{...}],
 *     "createdAt": "2021-02-18T16:54:12.000Z",
 *     "updatedAt": "2021-02-18T16:54:12.000Z",
 *     "deletedAt": null
 *   }
 * ]
 */
const taskTemplateFrom = (template) => {
  const defaultTitle =
    template.title ||
    template.translations[defaultLang]?.title ||
    text.findFirstTranslationFor(template.translations, 'title');

  const defaultDescription =
    template.description ||
    template.translations[defaultLang]?.description ||
    text.findFirstTranslationFor(template.translations, 'description');

  return {
    id: template.id,
    companyId: template.companyId,
    surveyTypeId: template.surveyTypeId,
    title: defaultTitle,
    description: defaultDescription,
    translations: template.translations,
    effectiveness: template.effectiveness,
    status: template.status,

    // REFACTOR: currently reducing each "category" object down to only its id.
    // Also, filtering all ids so that only *unique* ids remain.
    // TODO: Perhaps if the backend can send this data already formatted so that
    // each category data can be appended properly to the state (with multi-lang)
    // that would be easier than making another network request for all the
    // category data separately.
    categories: template.categories.map((c) => (nums.isNumeric(c) ? Number(c) : c.id)).filter(list.onlyUnique),

    createdAt: template.createdAt,
    updatedAt: template.updatedAt,
  };
};

const taskTemplatesFrom = (serverTemplateList = []) => {
  return serverTemplateList.map((serverTemplate) => taskTemplateFrom(serverTemplate));
};

export { taskTemplateFrom, taskTemplatesFrom };
